import store from '../store';
import history from './history';

export const VALID_CHARS_NAME = /^([a-zA-Z][a-zA-Z0-9][a-zA-Z0-9.]*)$/i;
export const VALID_CHARS = /^([a-zA-Z0-9][a-zA-Z0-9. -]*)$/i;
export const VALID_CHARS_DASH = /^([a-zA-Z0-9][a-zA-Z0-9.-]*)$/i;

export const getSessionId = () => {
  const sessionId = store.getState().session.sessionId;

  if (!sessionId) {
    history.push('/');
  }
  return sessionId;
};

export const getSelectedEntity = () => {
  const entity = store.getState().entities.selected;

  if (!entity) {
    history.push('/');
  }
  return entity;
};

export const removeMilliseconds = value => {
  const dateCreatedStr = `${value.dateCreatedStr}`;
  if (dateCreatedStr && /\.([0-9]{1,3})$/.test(dateCreatedStr)) {
    value.dateCreatedStr = dateCreatedStr.substring(
      0,
      dateCreatedStr.indexOf('.')
    );
  }
  return value;
};

export const isEmpty = obj => {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) return false;
  }
  return true;
};

export const isNotEmpty = obj => {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) return true;
  }
  return false;
};

export const isUnique = (isAdd, value, values) => {
  if (isAdd) {
    return !values.includes(value);
  }
  return true;
};

export const getRoundTitle = (id, round) => {
  return `Blocking Round: ${id} (${round.fields.length} Fields)`;
};

export const getRuleTitle = (id, rule) => {
  return `Matching Rule: ${id} (${rule.fields.length} Fields)`;
};

export const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
};

export const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

export const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
};

export const getPayloadFromError = err => {
  let payload =
    err && err.response && err.response.status
      ? 'Failed with error ' + err.response.status
      : '';
  if (err && err.response && err.response.data) {
    if (
      typeof err.response.data === 'object' &&
      err.response.data !== null &&
      err.response.data.message
    ) {
      payload = err.response.data.message;
    } else {
      payload = err.response.data;
    }
  }
  return payload;
};

export const lessOrEqualToOneRealRegExp = new RegExp(
  '^(1([.]?[0]?)|0[.]?[0-9]*)$'
);
export const decimalRegExp = new RegExp('^[0-9]*[.]?[0-9]*$');

export const formatRealNumber = (value, precision = 8) => {
  if (!value) {
    return value;
  }
  const fixedValue = value.toFixed(precision);
  value = parseFloat(fixedValue);
  return value;
};

export const getEntityById = id => {
  const { entities } = store.getState().entities;
  if (!entities) return null;
  const entity = entities.find(e => e.entityVersionId === id);
  return entity;
};

export const isUsingProbabilisticMatching = () => {
  const { selected } = store.getState().entities;
  const { systemConfig } = store.getState().systemConfig;

  if (!selected || !systemConfig) {
    return false;
  }

  const entityName = selected.name;

  if (!selected.name || !systemConfig[entityName]) {
    return false;
  }

  const matchingAlgorithm = systemConfig[entityName].matchingAlgorithmName;

  if (matchingAlgorithm === 'Probabilistic Matching Algorithm') {
    return true;
  }
  return false;
};

export const getProbMatchingFields = () => {
  const { selected } = store.getState().entities;
  const { systemConfig } = store.getState().systemConfig;
  const noFields = [];
  if (!selected || !systemConfig) {
    return noFields;
  }

  const entityName = selected.name;
  if (!selected.name || !systemConfig[entityName]) {
    return noFields;
  }

  const matchingAlgorithm = systemConfig[entityName].matchingAlgorithmName;

  if (matchingAlgorithm === 'Probabilistic Matching Algorithm') {
    const { matchingConfig } = store.getState().probMatching;
    const fields = matchingConfig.fields.map(field => field.fieldName);
    return fields;
  }
  return noFields;
};

export const convertDecimalToBaseTwo = (count, value) => {
  const digits = [];

  let index = 0;
  let dividend = value;
  while (index < count) {
    if (dividend > 1) {
      const result = Math.floor(dividend / 2);
      const remainder = dividend % 2;
      digits.push(remainder);
      dividend = result;
    } else if (dividend > 0) {
      digits.push(dividend);
      dividend = 0;
    } else {
      digits.push(0);
    }
    index++;
  }
  return digits;
};

export const convertDecimalToBaseThree = (count, value) => {
  const digits = [];

  let index = 0;
  let dividend = value;
  while (index < count) {
    if (dividend > 2) {
      const result = Math.floor(dividend / 3);
      const remainder = dividend % 3;
      digits.push(remainder);
      dividend = result;
    } else if (dividend > 0) {
      digits.push(dividend);
      dividend = 0;
    } else {
      digits.push(0);
    }
    index++;
  }
  return digits;
};

export const calcAgreementWeight = (mValue, uValue) => {
  return uValue < 0.00000001
    ? ''
    : formatRealNumber(Math.log2(mValue / uValue), 5);
};

export const calcDisagreementWeight = (mValue, uValue) => {
  return 1.0 - uValue < 0.00000001
    ? ''
    : formatRealNumber(Math.log2((1.0 - mValue) / (1.0 - uValue)), 5);
};

// create a filtered list of fields from the list of customMetrics
// as those field value indexes that don't already have a custom metric
// associated with their field
export const filterFieldValueIndexesByExistingCustomMetrics = (
  customMetrics,
  fieldValueIndexes
) => {
  const existingFields =
    customMetrics && customMetrics.length > 0
      ? new Set(customMetrics.map(cm => cm.fieldName))
      : new Set();
  // console.log('existingFields', JSON.stringify(existingFields));

  // filter the fieldValueIndexes to only those with a field that is not in the list of fields already used in custom metrics
  const fvis =
    fieldValueIndexes && fieldValueIndexes.length > 0
      ? fieldValueIndexes.filter(fvi => !existingFields.has(fvi.field))
      : [];
  return fvis;
};

// Search through list of users with the user with the id passed in as an argument
// and return the user object
export const getUserById = (users, id) => {
  if (!users || !id) return null;
  const user = users.find(u => u.id === id);
  return user;
};
